import React, { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import AddParameterModal from './AddParameterModal';

interface ParametersInterface {
    key: string;
    value: string;
}

const AddParameter = () => {
    const [parameters, setParameters] = useState<ParametersInterface[]>([]);
    const [isOpen, setIsOpen] = useState(false);

    const addParameter = () => {
        setIsOpen(true);
    };

    const handleSave = (newParameter: ParametersInterface) => {
        setIsOpen(false);
        setParameters((prev) => ([...prev, newParameter]));
    };

    return (
        <div>
            <div className="flex justify-end">
                <button
                    className="flex items-center gap-2 px-4 py-2 bg-[#2A2A2A] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                    onClick={addParameter}
                >
                    <FiPlus size={16} />
                    Add parameter
                </button>
            </div>

            <div className="mt-4 bg-[#2A2A2A] rounded-lg overflow-hidden">
                <table className="w-full">
                    <thead className='border border-white/[0.08]'>
                        <tr className="bg-[#1A1A1A] text-gray-400 text-sm">
                            <th className="text-left p-4 font-medium">Key</th>
                            <th className="text-left p-4 font-medium">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {parameters.map((parameter, index) => (
                            <tr key={index} className="border-b border-white/[0.08] hover:bg-[#3a3a3a33]">
                                <td className="p-4 text-gray-400">{parameter.key}</td>
                                <td className="p-4 text-gray-400">{parameter.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <AddParameterModal isOpen={isOpen} onClose={() => setIsOpen(false)} onSave={handleSave} />
        </div>
    );
};

export default AddParameter;
